// Import mutations
import { GET_FIRSTINTERVENANTS } from '../mutation-types'

const state = { all: [] }

const mutations = {
  [GET_FIRSTINTERVENANTS] (state, firstintervenants) {
    state.all = firstintervenants
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/firstintervenants.js